import { render } from "./TestButton.vue?vue&type=template&id=68538d9a&scoped=true"
import script from "./TestButton.vue?vue&type=script&lang=js"
export * from "./TestButton.vue?vue&type=script&lang=js"

import "./TestButton.vue?vue&type=style&index=0&id=68538d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68538d9a"]])

export default __exports__